/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import styles from '../../../styles/partials/logo.scss';

const propTypes = {
    link: PropTypes.string,
    label: PropTypes.string,
    expand: PropTypes.bool,
    dark: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    link: '/',
    label: 'Catbird Productions',
    expand: false,
    dark: false,
    className: null,
};

const Logo = ({
    link, dark, label, expand, className,
}) => (
    <div
        className={classNames({
            [styles.container]: true,
            [styles.expand]: expand,
            [styles.dark]: dark,
            [className]: className !== null,
        })}
    >
        <Link to={link} className={styles.link}>
            {label}
        </Link>
    </div>
);

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;



// WEBPACK FOOTER //
// ./js/components/partials/Logo.jsx